import { render, staticRenderFns } from "./buttonfilter.vue?vue&type=template&id=1b2d07a8&scoped=true&"
import script from "./buttonfilter.vue?vue&type=script&lang=js&"
export * from "./buttonfilter.vue?vue&type=script&lang=js&"
import style0 from "./buttonfilter.vue?vue&type=style&index=0&id=1b2d07a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d07a8",
  null
  
)

export default component.exports